import { unEncapsulate } from "./miroEncapsulator";

export function addBoundsToItem(item: any) {
  //takes an item
  // returns a bounds {left, right, top, bottom, centerX, centerY}
  item.bounds = getBoundsOfItem(item);

  return item;
}

export function getBoundsOfItem(item: any) {
  //takes an item
  // returns a bounds {left, right, top, bottom, centerX, centerY}
  const tempItem = unEncapsulate(item)

  return {
    left: tempItem.x - 0.5 * tempItem.width,
    right: tempItem.x + 0.5 * tempItem.width,
    top: tempItem.y - 0.5 * tempItem.height,
    bottom: tempItem.y + 0.5 * tempItem.height,
    centerX: tempItem.x,
    centerY: tempItem.y,
  };

}
